import {Constants} from '../view-constants.js';
import {useCallback, useContext} from 'react';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {useDispatch} from 'react-redux';
import {deleteFilterParams, getContentAjaxUrl} from '../ArticleOverviewHelper.js';
import {setContentAjaxCall} from '../AjaxCallSlice.jsx';

export const useChangeFilters = () => {
    const dispatch = useDispatch();

    const aoStaticContext = useContext(articleOverviewStaticContext);
    if (!aoStaticContext) {
        throw new Error('useChangeFilters must be used within an ArticleOverviewStaticContextProvider');
    }

    const {currentSearchParams, currentCategoryPath, contentAjaxUrl} = aoStaticContext;

    const setFilters = useCallback(
        (params) => {
            params.delete(Constants.SEARCH_PARAMS_PAGE);
            params.delete(Constants.SEARCH_PARAMS_ANCHOR);

            const formattedParams = `?${params.toString()}`;

            currentSearchParams.current = params;

            const contentAjaxCall = getContentAjaxUrl(currentCategoryPath.current, formattedParams, contentAjaxUrl);
            dispatch(setContentAjaxCall([contentAjaxCall, false]));
        },
        [dispatch, currentSearchParams, currentCategoryPath, contentAjaxUrl],
    );

    const resetFilters = useCallback(
        (deleteSort = false) => {
            const params = deleteFilterParams(currentSearchParams.current);
            if (deleteSort) {
                params.delete(Constants.SEARCH_PARAMS_ORDERING);
            }
            setFilters(params);
        },
        [setFilters, currentSearchParams.current],
    );

    return {setFilters, resetFilters};
};
